// src/components/ContactForm.js
import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './BookingForm.css'; // tu peux réutiliser le même style

import { auth } from '../firebase';

export default function ContactForm({ teacherName }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setFormData((prev) => ({
          ...prev,
          email: user.email || '',
          name: user.displayName || '',
        }));
      }
    });
    return () => unsubscribe();
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    if (success) setSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const templateParams = {
      teacherName,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    try {
      await emailjs.send(
        'SERVICE_ID',
        'template_pgdt8yl',
        templateParams,
        'udMka3n0REP1MEHEo'
      );
      setSuccess(true);
      setFormData({
        name: auth.currentUser?.displayName || '',
        email: auth.currentUser?.email || '',
        phone: '',
        message: '',
      });
    } catch (error) {
      console.error('Erreur EmailJS:', error);
      alert("Une erreur est survenue lors de l'envoi. Veuillez réessayer.");
    }
  };

  return (
    <div className="booking-form">
      <h3>Contacter {teacherName}</h3>

      {success && (
        <p className="success-msg">✅ Votre message a été envoyé avec succès !</p>
      )}

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Votre nom"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Votre email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <input
          type="tel"
          name="phone"
          placeholder="Votre numéro de téléphone"
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <textarea
          name="message"
          placeholder="Message ou détails"
          value={formData.message}
          onChange={handleChange}
          rows={4}
          required
        />

        <button type="submit">
          Envoyer le message
        </button>
      </form>
    </div>
  );
}
